export const stopResultValues = {
  correct: "correct",
  incident: "incident",
};

const routeStopFinalizeStatuses = {
  finalized: "FINALIZADO",
  incident: "INCIDENCIA",
};

export function createLoadUnloadFinalizePayload({ selectedStopResult, observations }) {
  const isIncident = selectedStopResult === stopResultValues.incident;
  const status = isIncident
    ? routeStopFinalizeStatuses.incident
    : routeStopFinalizeStatuses.finalized;

  return {
    delivery_info: {
      observations: normalizeText(observations),
      status,
      status_description: isIncident ? "" : "Finalizado",
    },
  };
}

export function canFinalizeLoadUnload({ isSubmitting, routeStop }) {
  return !isSubmitting && Boolean(routeStop);
}

export function validateLoadUnloadFinalize({ selectedStopResult, observations }) {
  if (
    selectedStopResult === stopResultValues.incident &&
    !normalizeText(observations)
  ) {
    return "Escribe unas observaciones para continuar.";
  }

  return "";
}

function normalizeText(value) {
  return value?.trim?.() ?? "";
}
